import React, {useEffect, useState} from "react";
import Queue from "./Queue";
import CurrentlyPlaying from "./CurrentlyPlaying";
import History from "./History";
import { FaRandom } from "react-icons/fa";


const QueueHistoryMenu = ({socket, onSkip, cookies}) => {
    const [tabIndex, setTabIndex] = useState(0);
    const [deepSearch, setDeepSearch] = useState(false);
    const [queue, setQueue] = useState([]);
    const [history, setHistory] = useState([]);
    const [topVideos, setTopVideos] = useState([]);
    const [filter, setFilter] = useState('');
    const [serverHistory, setServerHistory] = useState([]);
    const [hallVideos, setHallVideos] = useState([]);

    useEffect(() => {
        if (socket != null){
            socket.on('currentQueue', (res) => {
                setQueue(res.queue);
            });
            socket.on('currentHistory', (res) => {
                setServerHistory(res.history);
                setTopVideos(res.top);
                setHallVideos(res.hof);
            });
            socket.on('filteredHistory', (res) => {
                setHistory(res);
                setDeepSearch(true);
            });
            socket.on('forceRefreshHistory', (res) => {
                setServerHistory(res);
                setHistory(res);
                setFilter('');
                setDeepSearch(false);
            });
        }
    });

    if(serverHistory != history && !deepSearch && filter == ""){
        setHistory(serverHistory)
    }

    if (tabIndex != 1 && filter !== ''){
        setFilter('');
        setDeepSearch(false);
    }

    return (
        <div className='QueueHistoryMenu'>
            <CurrentlyPlaying socket={socket} onSkip={onSkip} cookies={cookies}/>
            <h3 className={tabIndex == 0 ? 'QHTab SelectedTab':'QHTab'} onClick={() => {setTabIndex(0)}} style={{cursor: "pointer"}}>Queue</h3>
            <h3 className={tabIndex == 1 ? 'QHTab SelectedTab':'QHTab'} onClick={() => {setTabIndex(1)}} style={{cursor: "pointer"}}>History</h3>
            <h3 className={tabIndex == 2 ? 'QHTab SelectedTab':'QHTab'} onClick={() => {setTabIndex(2)}} style={{cursor: "pointer"}}>Top</h3>
            <h3 className={tabIndex == 3 ? 'QHTab SelectedTab':'QHTab'} onClick={() => {setTabIndex(3)}} style={{cursor: "pointer"}}>Popular</h3>
            <FaRandom className='shuffleButton' onClick={() => {socket.emit('queueRandom')}}/>
            <div className='QueueHistoryContainer'>
                {tabIndex == 0 && <Queue socket={socket} queue={queue}/>}
                {tabIndex == 1 && <>
                        <input type={'text'} className='TextField' style={{width: '80%', 'display':'block', 'margin-left': 'auto', 'margin-right': 'auto'}} placeholder="Search History" size="small" variant='filled' value={filter} autoComplete="off" onChange={(e)=>{
                            setFilter(e.target.value)
                            if(!deepSearch){
                                if(e.target.value !=''){
                                    let filtered = []
                                    serverHistory.forEach((video)=> {
                                        if(video.title.toUpperCase().includes(e.target.value.toUpperCase())){
                                            filtered.push(video);
                                        }
                                    });
                                    setHistory(filtered);
                                }else{
                                    setHistory(serverHistory);
                                }
                            }
                            if(e.target.value == ''){
                                socket.emit('forceRefreshHistory')
                            }
                        }}/>
                    <History socket={socket} history={history} filter={filter} deepSearch={deepSearch} cookies={cookies}/>
                    </>
                }
                {tabIndex == 2 && <History socket={socket} history={topVideos} filter={''} deepSearch={false} cookies={cookies}/>}
                {tabIndex == 3 && <History socket={socket} history={hallVideos} filter={''} deepSearch={false} cookies={cookies}/>}
            </div>

        </div>
    )
}

export default QueueHistoryMenu;